module.exports = "/build/web/svg/Google-Play-Badge.02455dd588c190d65048a4dd2c5c5f06.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/Google-Play-Badge.svg
// module id = 167
// module chunks = 24